/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import { MdTimer } from "react-icons/md";
import PropTypes from "prop-types";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: grey;
  font-size: ${props => (props.fontSize !== null ? props.fontSize : "unset")};
`;

const StyledTitle = styled.span`
  margin-left: 4px;
  font-size: 0.7em;
`;

class CountdownLabel extends Component {
  render() {
    const { title, fontSize, style } = this.props;

    return (
      <StyledContainer style={style} fontSize={fontSize}>
        <MdTimer color={"grey"} size={"1em"} />
        <StyledTitle>{title}</StyledTitle>
      </StyledContainer>
    );
  }
}

CountdownLabel.propTypes = {
  fontSize: PropTypes.string,
  title: PropTypes.string.isRequired,
  style: PropTypes.object
};

CountdownLabel.defaultProps = {
  title: "--:--"
};

export default CountdownLabel;



// WEBPACK FOOTER //
// ./src/components/CountdownLabel.js